import React from "react";
import Image from "next/image";
import Link from "next/link";
import { BASE_ASSETS_URL } from "@constants/constants";
const ProfileCard = ({ name, role, socialLinks, image, bgColor }) => {
  return (
    <div className="w-full flex flex-col gap-8  border border-surface-dark rounded-2xl transition-all duration-500 ease-in-out overflow-hidden bg-white">
      <div className={`w-full aspect-square  bg-surface-dark`}>
        <Image
          src={`${BASE_ASSETS_URL}/v2/clm/about/our_team/${image}`}
          width={10}
          height={10}
          alt={name}
          loading="lazy"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex flex-col justify-center items-center text-center gap-2 pb-6 px-6">
        <h1 className="text-2xl font-bold">{name}</h1>
        <p className="text-gray-600 text-lg font-semibold">{role}</p>
        <div className="flex justify-center items-center gap-4">
          {socialLinks.map((socialLink, index) => (
            <Link href={`${socialLink.link}`} key={index}>
              <div className="text-md bg-white hover:bg-black text-gray-800 hover:text-white w-[30px] h-[30px] border border-gray-700 rounded-full grid place-items-center transition-all duration-500">
                {socialLink.icon}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProfileCard;
